{
  "schemaVersion": "1.0",
  "status": "DRAFT_DIRECTIONAL",
  "note": "Directional marketing content. Prices are management targets; public-pricing.json must be generated from Pricing Master at publish.",
  "id": "operate",
  "order": 4,
  "accent": "deep-blue",
  "eyebrow": "AIRWORTHINESS & READINESS",
  "title": "Operate",
  "valueStatement": "Manage maintenance obligations, aircraft status, compliance, and readiness.",
  "outcome": "Know what must be maintained.",
  "workflow": [
    "Program",
    "Forecast",
    "Plan",
    "Coordinate",
    "Accept records",
    "Ready"
  ],
  "intelligenceInContext": {
    "name": "complianceIQ",
    "headline": "Explains status and assembles evidence for review.",
    "helpsWith": [
      "Explain why an item is due",
      "Organize AD/SB/LLP evidence",
      "Prepare readiness briefings"
    ],
    "drawsOn": [
      "Intelligence",
      "Vault"
    ],
    "humanAuthority": "Airworthiness and applicability determinations stay with authorized personnel.",
    "aiUsage": "Evidence assembly and analysis use credits."
  },
  "evidenceProduced": [
    "AD/SB compliance evidence",
    "Readiness packages",
    "Accepted maintenance records"
  ],
  "regulatory": {
    "anchors": [
      "a025",
      "part-39",
      "p91-417",
      "p135-records"
    ],
    "included": [
      "AD/LLP status evidence",
      "Review workflows",
      "Audit trail"
    ],
    "readinessServices": [
      "ext-a025-readiness",
      "ext-conformity-review"
    ]
  },
  "pricingId": "operate",
  "showExtensions": true
}